import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-86" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-87" data-mp="1o3dj01a9xtlv">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-blue-50 ring-1 ring-blue-100" data-id="element-88" data-mp="2223lxxjryni5">
          <ShieldCheckIcon className="h-8 w-8 text-blue-600" aria-hidden="true" data-id="element-89" data-mp="1x28spncj1ltx" />
        </span>

        <h2 className="mt-7 font-display text-[2rem] font-extrabold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-90" data-mp="19f0qxfeb4uwn">
          Garantía de 7 días
        </h2>

        <p className="mt-6 text-lg text-ink md:text-xl" data-id="element-91" data-mp="1j5lu7g4xenlw">
          Probalo durante 7 días. Si el material no es lo que esperabas, podés solicitar el reembolso
          del 100% dentro del período de garantía.
        </p>
        <p className="mt-4 text-blue-900/70" data-id="element-92" data-mp="qmoo6rjqrrlz">Sin vueltas.</p>
      </div>
    </section>;
}